import { TextInput } from 'dw-au-react-components';
import React, { useContext, useEffect, useState } from 'react';
import useForm from 'react-hook-form';
import { CartContext } from '../../../Context/CartContext';
import { CloseIcon } from '../../../svg';
import { UserContext } from '../../../Context/User';

const VelocityFrequentFlyerForm = () => {
	const {
		addVelocityNumber,
		removeVelocityNumber,
		velocityNumber,
		setVelocityNumberError,
	} = useContext(CartContext);

	const { defaultVelocityNumber } = useContext(UserContext);
	const [showCloseBtn, setShowCloseBtn] = useState(false);
	const [velocityNumberValue, setVelocityNumberValue] = useState('');

	const __allowOnlyDigits = (inputValue) => {
		if (isNaN(inputValue)) {
			return 'Please enter only digits!';
		}
	};

	const { register, errors } = useForm({
		mode: 'onBlur',
		defaultValues: {
			velocityNumber: velocityNumber,
		},
	});

	const handleOnChange = (e) => {
		let voucherValue = e.target.value;
		setVelocityNumberValue(voucherValue);
		setVelocityNumberError(false);

		if (voucherValue.length > 9 && !isNaN(voucherValue)) {
			addVelocityNumber(voucherValue);
			setShowCloseBtn(true);
		} else {
			if (voucherValue.length > 0) {
				setVelocityNumberError(true);
			}

			setShowCloseBtn(false);
			removeVelocityNumber();
		}
	};

	const handleOnClick = () => {
		setVelocityNumberValue('');
		removeVelocityNumber();
		setShowCloseBtn(false);
	};

	useEffect(() => {
		if (defaultVelocityNumber) {
			setVelocityNumberValue(defaultVelocityNumber);
			setShowCloseBtn(true);
		}
	}, []);

	let error = false;
	let helperText = null;
	if (errors.velocityNumber) {
		error = true;
		helperText = errors.velocityNumber.message;
	}

	return (
		<TextInput
			maxLength={10}
			helperText={helperText}
			placeholder='Velocity membership number'
			error={error}
			onChange={handleOnChange}
			icon={
				showCloseBtn ? (
					<CloseIcon onClick={handleOnClick} className='cursor-pointer' />
				) : null
			}
			register={register({
				minLength: {
					value: 10,
					message: 'Please enter Minimum of 10 digits',
				},
				maxLength: {
					value: 10,
				},
				validate: {
					validateInput: (inputValue) => __allowOnlyDigits(inputValue),
				},
			})}
			name='velocityNumber'
			value={velocityNumberValue}
		/>
	);
};

export default VelocityFrequentFlyerForm;
